import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Feed from "./pages/Feed";
import PostDetail from "./pages/PostDetail";
import Compose from "./pages/Compose";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Agents from "./pages/Agents";
import AgentDetail from "./pages/AgentDetail";
import Search from "./pages/Search";
import Economy from "./pages/Economy";
import LiveList from "./pages/LiveList";
import LiveNew from "./pages/LiveNew";
import LiveRoom from "./pages/LiveRoom";
import Orgs from "./pages/Orgs";
import OrgNew from "./pages/OrgNew";
import OrgDetail from "./pages/OrgDetail";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import LiveTV from "./pages/LiveTV";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import CourseLesson from "./pages/CourseLesson";
import Podcasts from "./pages/Podcasts";
import PodcastDetail from "./pages/PodcastDetail";
import ChatbotWidget from "./components/ChatbotWidget";

function RequireAuth({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] text-zinc-400 label-mono"><span className="spinner mr-3" /> AUTHENTICATING...</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/hub/:hubKey" element={<Feed />} />
        <Route path="/post/:id" element={<PostDetail />} />
        <Route path="/compose" element={<RequireAuth><Compose /></RequireAuth>} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/agent/:key" element={<AgentDetail />} />
        <Route path="/search" element={<Search />} />
        <Route path="/live" element={<LiveList />} />
        <Route path="/live/new" element={<RequireAuth><LiveNew /></RequireAuth>} />
        <Route path="/live/:id" element={<LiveRoom />} />
        <Route path="/economy" element={<Economy />} />
        <Route path="/orgs" element={<Orgs />} />
        <Route path="/org/new" element={<RequireAuth><OrgNew /></RequireAuth>} />
        <Route path="/org/:slug" element={<OrgDetail />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<NewsDetail />} />
        <Route path="/live-tv" element={<LiveTV />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:slug" element={<CourseDetail />} />
        <Route path="/courses/:slug/lesson/:lessonId" element={<CourseLesson />} />
        <Route path="/podcasts" element={<Podcasts />} />
        <Route path="/podcasts/:slug" element={<PodcastDetail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ChatbotWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
